import styled from 'styled-components';

export const SidebarContainer = styled.div`
  aside {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: 50px;
    height: calc(100vh - 50px * 2);
  }

  /* Will be show only on mogile and tablets */
  aside button#close-btn {
    display: none;
  }

  aside .sidebar .sidebar-menu {
    margin-bottom: 0.5rem;
  }

  aside .sidebar .sidebar-menu span,
  aside .sidebar .logout span {
    font-size: 1.7rem;
    margin-left: 3rem;
    transition: all 0.3s;
  }

  aside .sidebar .sidebar-menu .sidebar-dropdown {
    cursor: pointer;
  }

  aside .sidebar .sidebar-menu .dropdown-item {
    height: 0;
    opacity: 0;
    transition: all 0.3s 0.2s;
  }

  aside .sidebar .sidebar-menu .dropdown-item.show {
    height: 47rem;
    opacity: 1;
  }

  aside .sidebar .sidebar-menu .dropdown-item a {
    margin-left: 3rem;
    opacity: 0;
    transition: all 0.3s;
  }

  aside .sidebar .sidebar-menu .dropdown-item.show a {
    opacity: 1;
  }
  .sidebar-menu .sidebar-dropdown,
  aside .sidebar a,
  aside .sidebar .logout {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    height: 2.8em;
    color: var(--color-gray-light);
    position: relative;
  }

  aside .sidebar .sidebar-menu a.active {
    background: var(--color-white);
    color: var(--color-primary);
    transition: all 0.3s ease-in-out;
  }

  aside .sidebar a.active::before {
    content: '';
    width: 6px;
    height: 100%;
    position: absolute;
    background: var(--color-primary);
  }

  .sidebar-menu .sidebar-dropdown:hover,
  aside .sidebar .sidebar-menu a:hover,
  aside .sidebar .logout:hover {
    color: var(--color-primary);
  }

  aside .sidebar .sidebar-menu a:hover span,
  aside .sidebar .logout:hover span {
    margin-left: 2rem;
  }

  aside .sidebar .sidebar-menu h3 {
    font-size: 12px;
  }

  aside .sidebar .sidebar-menu h4 {
    font-weight: 500;
  }

  aside .sidebar .sidebar-menu span.badge {
    font-size: 1rem;
    width: 1.5rem;
    background: crimson;
    color: white;
    border-radius: var(--border-radius-1);
    display: flex;
    justify-content: center;
  }

  aside .sidebar .logout {
    margin-top: 2rem;
  }

  /* ===================== MEDIA QUERIES ===================== */

  @media screen and (max-width: 1200px) {
  }

  @media screen and (max-width: 1024px) {
    aside {
      position: fixed;
      top: 0;
      left: -100%;
      z-index: 8;
      background: var(--color-white);
      width: 22rem;
      height: 100vh;
      box-shadow: 0.5rem 0 1rem var(--color-primary-light);
      transition: left 0.8s ease;
      overflow-y: auto;
    }

    aside.show {
      left: 0;
    }

    aside .sidebar h3:first-child {
      margin-left: 2rem;
      margin-top: 1rem;
    }
    aside .sidebar h3 {
      margin-left: 2rem;
    }

    aside button#close-btn {
      display: inline-block;
      width: 3rem;
      height: 3rem;
      position: absolute;
      right: 1rem;
      z-index: 8;
      background: transparent;
      color: var(--color-dark);
    }

    aside .sidebar a.active {
      background: var(--color-primary-light);
      color: var(--color-primary);
    }

    .sidebar-menu .sidebar-dropdown,
    aside .sidebar a,
    aside .sidebar .logout {
      height: 2.4rem;
    }

    aside .sidebar .sidebar-menu .dropdown-item.show {
      height: 41rem;
    }
  }

  /* @media screen and (min-width: 1600px) {
    aside .sidebar .sidebar-menu h3 {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 1900px) {
    aside .sidebar .sidebar-menu h3 {
      font-size: 16px;
    }
  } */
`;
